import React, { useState, useEffect } from "react";
import {
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
} from "reactstrap";
import DeleteModal from "components/Common/DeleteModal";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import { SuccessOk } from "configs/statusCode";
import { toast } from "react-toastify";
import { adminPrefix } from "configs/routePrefix";
import { useSelector } from "react-redux";

const CardItem = (props) => {
	const {
		index,
		item,
		id,
		Service,
		name,
		status,
		getList,
		history,
		setShouldGetData,
	} = props;
	const [deleteModal, setDeleteModal] = useState(false);
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const [itemStatus, setItemStatus] = useState(false);
	const service = new Service();
	const AuthData = useSelector((state) => state.Auth);
	const isExist = (data) =>
		AuthData.permissions.includes(data) || AuthData.email === "admin@meras.com";
	const toggle = () => setDropdownOpen((prevState) => !prevState);

	useEffect(() => {
		setItemStatus(status);
	}, [status]);

	const handleCloseModal = (action, response) => {
		setDeleteModal(false);
		if (action === "delete") {
			setShouldGetData(true);
		}
	};

	const changeStatus = (e) => {
		const value = e.target.checked;
		service.toggleStatus(id).then((res) => {
			if (res && res.status === SuccessOk) {
				setItemStatus(value);
				toast.success("Role Status updated successfully");
				setTimeout(() => {
					getList();
				}, 1000);
			}
		});
	};

	return (
		<>
			<tr key={index}>
				<td className="font-size-16">{id}</td>
				<td className="font-size-16">{name.en}</td>
				<th className="font-size-16">{item.users_count}</th>
				<td className="font-size-14 py-0">
					<form>
						<div className="form-check form-switch form-switch-md mb-1">
							<input
								name="status"
								checked={itemStatus}
								type="checkbox"
								className="form-check-input"
								id="has_status"
								onChange={changeStatus}
								disabled={isExist("role.edit") ? false : true}
							/>
						</div>
					</form>
				</td>
				{isExist("role.edit") || isExist("role.delete") ? (
					<td className="removebtnhover">
						<Dropdown
							className="dropdownWidth"
							color="light"
							isOpen={dropdownOpen}
							toggle={toggle}>
							<DropdownToggle caret>
								<i className="fa fa-ellipsis-v text-dark fa-lg"></i>
							</DropdownToggle>
							{/* {index > 0  ? <DropdownMenu> */}
							<DropdownMenu>
								{isExist("role.edit") ? (
									<DropdownItem
										onClick={() => {
											history.push(
												`${adminPrefix}/setting/roles/roles-update/${id}`
											);
										}}>
										Edit
									</DropdownItem>
								) : null}
								{isExist("role.delete") ? (
									<DropdownItem
										className="text-danger"
										onClick={() => {
											setDeleteModal(!deleteModal);
										}}>
										Remove Role
									</DropdownItem>
								) : null}
							</DropdownMenu>
							{/* </DropdownMenu> :null} */}
						</Dropdown>
					</td>
				) : null}
			</tr>
			<DeleteModal
				open={deleteModal}
				titleMsg={name.en}
				deletedItem={item}
				modelService={service}
				onCloseModal={(action) => handleCloseModal(action)}
			/>
		</>
	);
};

export default CardItem;
